import React, { Component, useEffect } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCollapse,
  CRow,
  CImg,
  CCol,
  CLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CPagination
} from "@coreui/react";
import { Portal } from "@material-ui/core";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import logoEducandus from "../../assets/imgs/logo_original.png";
import URL from "../../config/api";
import axios from "../../config/axios";
import { debounce } from "../../utils/debounce";
import UsersCommunityModal from "../CommunityModal/users";
import UserStatistics from "../CommunityModal/userStatistics";
import Loading from "../Loading";
import DataTable from "../Tables/tables";

class CommunityContentUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // room: null,
      // disciplines: null,
      // tab: 1,
      waiting: true,
      members: true,
      deleteModal: false,
      deleteId: null,
      statisticsModal: null,
      usersModal: false,
      studentListSize: undefined,
      studentsListPage: 1,
      sizePerPage: 10,
      toggleShowAllUsersActivated: true,
      users: [],
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      generatingAccessCards: false,
      accessCardsModal: false,
      // Cartões já gerados nesta sessão. As senhas em texto só existem aqui:
      // o banco guarda apenas o hash, e fechar o modal as descarta.
      accessCardsResult: null
    };
    this.toggleShowAllUsers = this.toggleShowAllUsers.bind(this);
    this.openAccessCardsModal = this.openAccessCardsModal.bind(this);
    this.closeAccessCardsModal = this.closeAccessCardsModal.bind(this);
    this.handleAccessCards = this.handleAccessCards.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handleUsers();
    this.fetchUsers(1);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.toggleShowAllUsersActivated !==
      this.state.toggleShowAllUsersActivated
    ) {
      const delayedSearch = debounce(() => this.handleUsers(), 300);
      delayedSearch();
    }
  }

  async handleUsers() {
    this.setState({ loading: true });
    const objRoomUser = { room: this.props.match.params };

    await axios
      .post(
        `${URL.api}community/room_user/listPaginate?page=${this.state.studentsListPage}&offset=${this.state.sizePerPage}`,
        objRoomUser,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (this.props.isRoom) {
            this.setState({
              users: resp.data.data?.users.map(user => ({
                ...user,
                start: new Date(user.start).toLocaleDateString("pt-br", {
                  year: "numeric",
                  day: "numeric",
                  month: "short"
                })
              })),
              studentsListPage: resp.data.meta.current_page,
              studentListSize: resp.data.meta.total,
              loading: false
            });
          } else {
            let users = resp.data.data.users.map(user => ({
              ...user,
              disciplines: resp.data.data.disciplines.filter(
                discipline => discipline.room_user_id === user.id
              )
            }));
            this.setState({
              users: users.map(user => ({
                ...user,
                start: new Date(user.start).toLocaleDateString("pt-br", {
                  year: "numeric",
                  day: "numeric",
                  month: "short"
                })
              })),
              studentsListPage: resp.data.meta.current_page,
              studentListSize: resp.data.meta.total,
              loading: false
            });
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  toggleShowAllUsers() {
    if (this.state.toggleShowAllUsersActivated) {
      this.setState({
        studentsListPage: 1,
        sizePerPage: 1000,
        toggleShowAllUsersActivated: false
      });
    } else {
      this.setState({
        studentsListPage: 1,
        sizePerPage: 10,
        toggleShowAllUsersActivated: true
      });
    }
  }

  // URL de login do app do aluno. Enquanto o PWA não tem domínio próprio, o QR
  // aponta para a tela de login padrão. Resolvido por ambiente: só produção usa
  // o domínio sem "homologa".
  accessCardsLoginUrl() {
    const isProduction = window.location.host
      .toLowerCase()
      .includes("ava.educandus");

    return isProduction
      ? "https://login.educandus.com.br/login?from=ava"
      : "https://homologa.login.educandus.com.br/login?from=ava";
  }

  openAccessCardsModal() {
    this.setState({ accessCardsModal: true, accessCardsResult: null });
  }

  closeAccessCardsModal() {
    if (this.state.generatingAccessCards) return;
    // Descarta as senhas em texto ao fechar. Não há como reexibi-las depois.
    this.setState({ accessCardsModal: false, accessCardsResult: null });
  }

  // Só é chamado depois da confirmação no modal: redefine a senha de todos os
  // alunos da turma, então não pode disparar sozinho.
  async handleAccessCards() {
    if (this.state.generatingAccessCards) return;

    this.setState({ generatingAccessCards: true });

    const loginUrl = this.accessCardsLoginUrl();

    try {
      const cardsResp = await axios.post(
        `${URL.api}community/room_user/accessCards`,
        { room_id: this.props.match.params.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      if (!cardsResp.data.success) {
        this.error(
          cardsResp.data.error || "Não foi possível gerar os cartões."
        );
        return;
      }

      const { room, students } = cardsResp.data.data;

      if (!students || students.length === 0) {
        toastr.warning("Atenção", "Esta turma não possui alunos.");
        return;
      }

      // Um único QR para a turma: a URL de login é a mesma para todos.
      let qrImage = null;
      try {
        const qrResp = await axios.get(
          `${URL.api}qrcode?url=${encodeURIComponent(loginUrl)}`
        );
        if (qrResp.data.success) qrImage = qrResp.data.data;
      } catch (qrError) {
        // O cartão continua útil sem o QR; o aluno acessa pelo endereço impresso.
        qrImage = null;
      }

      // Guarda em vez de imprimir direto: as senhas já foram gravadas, então se
      // a impressão falhar o professor ainda as tem na tela e não precisa gerar
      // de novo (o que invalidaria a folha anterior).
      this.setState({ accessCardsResult: { room, students, qrImage } });
    } catch (error) {
      // O endpoint responde com status real (403/422), então axios cai aqui e a
      // mensagem específica do backend fica em error.response.
      this.error(
        error?.response?.data?.error ||
          "Não foi possível gerar os cartões de login."
      );
    } finally {
      this.setState({ generatingAccessCards: false });
    }
  }

  printAccessCards(room, students, qrImage) {
    const escapeHtml = value =>
      String(value === null || value === undefined ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    // Vira o nome sugerido do arquivo quando o professor escolhe "Salvar como PDF".
    const roomName = escapeHtml(room.name);

    // O CRA resolve o import para um caminho relativo (/static/media/...).
    // Dentro do iframe montado por document.write o relativo pode não resolver,
    // então absolutiza contra a origem da página. Usa window.URL porque o
    // identificador URL neste arquivo é o config da API.
    const logoUrl = escapeHtml(
      new window.URL(logoEducandus, window.location.href).href
    );

    const cards = students
      .map(student => {
        const password = `<span class="value password">${escapeHtml(
          student.password
        )}</span>`;

        const qrBlock = qrImage
          ? `<img class="qr" src="${escapeHtml(
              qrImage
            )}" alt="QR Code de acesso" />`
          : `<div class="qr placeholder">QR indisponível</div>`;

        return `
      <div class="card">
        <div class="info">
          <div class="student">${escapeHtml(student.name)}</div>
          <div class="creds">
            <div class="field"><span class="label">Login</span>${`<span class="value login">${escapeHtml(
              student.username
            )}</span>`}</div>
            <div class="field"><span class="label">Senha</span>${password}</div>
          </div>
        </div>
        <div class="access">
          ${qrBlock}
          <div class="access-label">Acesse o nosso aplicativo!</div>
        </div>
      </div>`;
      })
      .join("");

    // Documento autocontido: nada de CSS externo, para imprimir igual em
    // qualquer navegador. Folha A4 com grade de 2 colunas, sem quebrar cartão
    // ao meio entre páginas.
    const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="utf-8" />
<title>Cartões de login - ${roomName}</title>
<style>
  * { box-sizing: border-box; }
  @page { size: A4; margin: 9mm; }
  html, body { margin: 0; padding: 0; background: #fff;
               font-family: "Segoe UI", Tahoma, Arial, Helvetica, sans-serif;
               color: #1f2d3d; -webkit-print-color-adjust: exact; print-color-adjust: exact; }

  .header { text-align: center; margin-bottom: 4mm; }
  .header img { height: 1cm; width: auto; }
  .header .tagline { font-size: 10px; color: #7a8ba0; margin-top: 2mm;
                     letter-spacing: .04em; }

  .sheet { display: grid; grid-template-columns: 1fr 1fr; gap: 4mm; }

  .card { position: relative; overflow: hidden;
          border: 1px solid #dbe3ec; border-radius: 10px;
          padding: 10px 12px 10px 14px;
          display: flex; align-items: center; gap: 10px; min-height: 3.3cm;
          background: #fff;
          page-break-inside: avoid; break-inside: avoid; }
  /* Faixa colorida na lateral, no lugar da borda tracejada de formulário. */
  .card::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0;
                  width: 5px; background: #1b7fc4; }

  .info { flex: 1; min-width: 0; }
  .student { font-size: 12.5px; font-weight: 700; color: #14293d;
             line-height: 1.3; margin-bottom: 6px; word-break: break-word; }

  .creds { background: #f4f8fc; border-radius: 6px; padding: 6px 8px; }
  .field { font-size: 11.5px; display: flex; align-items: baseline; gap: 6px; }
  .field + .field { margin-top: 3px; }
  .label { color: #8194a8; font-size: 9.5px; text-transform: uppercase;
           letter-spacing: .06em; min-width: 38px; }
  .value { font-weight: 700; color: #14293d; }
  .login, .password { font-family: "Consolas", "Courier New", monospace;
                      font-size: 12.5px; letter-spacing: .02em; }

  .access { text-align: center; flex-shrink: 0; width: 2.3cm; }
  .qr { width: 2.3cm; height: 2.3cm; display: block; }
  .qr.placeholder { width: 2.3cm; height: 2.3cm; border: 1px dashed #c8d4e0;
                    border-radius: 6px; font-size: 8px; color: #a3b1c2;
                    display: flex; align-items: center; justify-content: center; }
  .access-label { font-size: 10px; font-weight: 700; color: #1b7fc4;
                  margin-top: 4px; line-height: 1.25; }
</style>
</head>
<body>
  <div class="header">
    <img src="${logoUrl}" alt="Educandus" />
    <div class="tagline">Seus dados de acesso à plataforma</div>
  </div>
  <div class="sheet">${cards}</div>
</body>
</html>`;

    this.printHtmlInHiddenFrame(html);
  }

  /**
   * Renderiza o HTML num iframe fora da tela e chama o diálogo de impressão.
   * Evita window.open(), que é barrado por bloqueadores de pop-up, e não deixa
   * aba sobrando para o professor fechar.
   */
  printHtmlInHiddenFrame(html) {
    const previous = document.getElementById("access-cards-print-frame");
    if (previous) previous.remove();

    const frame = document.createElement("iframe");
    frame.id = "access-cards-print-frame";
    frame.setAttribute("aria-hidden", "true");
    // Fora da viewport em vez de display:none — alguns navegadores não imprimem
    // iframes que não estão renderizados.
    frame.style.position = "fixed";
    frame.style.left = "-10000px";
    frame.style.top = "0";
    frame.style.width = "21cm";
    frame.style.height = "29.7cm";
    frame.style.border = "0";

    document.body.appendChild(frame);

    const doc = frame.contentDocument || frame.contentWindow.document;
    doc.open();
    doc.write(html);
    doc.close();

    const triggerPrint = () => {
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (error) {
        toastr.error("Fail", "Não foi possível abrir a impressão dos cartões.");
      }
    };

    // Espera as imagens (logo e QR) decodificarem antes de imprimir; sem isso a
    // primeira impressão pode sair com espaços vazios no lugar delas.
    const images = Array.from(doc.images || []);
    const pending = images
      .filter(img => !img.complete)
      .map(
        img =>
          new Promise(resolve => {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          })
      );

    Promise.all(pending).then(() => setTimeout(triggerPrint, 150));
  }

  toggleWaiting() {
    this.setState(state => ({ waiting: !state.waiting }));
  }

  toggleMembers() {
    this.setState(state => ({ members: !state.members }));
  }

  deleteRoomUser(roomUser) {
    axios
      .post(`${URL.api}community/room_user/delete/${roomUser}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleUsers();
          this.setState({ deleteModal: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  acceptRoomUser(roomUser) {
    const obj = {
      authorized: true
    };

    axios
      .post(`${URL.api}community/room_user/update/${roomUser}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.handleUsers();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  fetchUsers(page = 1) {
    const objRoomUser = { room: this.props.match.params };
    axios
      .post(
        `${URL.api}community/room_user/listPaginate?page=${page}&offset=${this.state.sizePerPage}`,
        objRoomUser,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(res => {
        const meta = res.data.meta;

        this.setState({
          users: res.data.data.users,
          currentPage: Number(meta.current_page),
          totalPages: Number(meta.last_page) // força número
        });
      })
      .catch(err => console.error(err));
  }

  /* Célula da coluna "Grupo(s)": os grupos daquela turma em que o aluno está.
     Badge cinza, discreto de propósito -- é informação de apoio numa tabela
     que já tem nome, papel e usuário competindo pela atenção.

     `flex-wrap` com gap mínimo: ficam colados na horizontal e, quando não
     couberem, descem para a linha seguinte em vez de esticar a coluna. O gap
     não é zero porque dois badges cinza encostados viram um bloco só. */
  cellGroups = cell => {
    if (!cell || cell.length === 0) {
      return <span className="text-muted">-</span>;
    }

    return (
      <div className="d-flex flex-wrap" style={{ gap: "2px" }}>
        {cell.map(group => (
          <span
            key={group.id}
            className="badge badge-secondary font-weight-normal"
            style={{ fontSize: "11px" }}
          >
            {group.name}
          </span>
        ))}
      </div>
    );
  };

  render() {
    return (
      <>
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            {this.state.statisticsModal && (
              <UserStatistics
                show={this.state.statisticsModal !== null}
                onClose={() => this.setState({ statisticsModal: null })}
                roomUser={this.state.statisticsModal}
                currentRoute={this.props.currentRoute}
                username={
                  this.state.users.find(
                    u => u.id === this.state.statisticsModal
                  ).user_name
                }
                userId={
                  this.state.users.find(
                    u => u.id === this.state.statisticsModal
                  ).user_id
                }
              />
            )}
            {this.state.usersModal && (
              <UsersCommunityModal
                show={this.state.usersModal !== null}
                onClose={shouldUpdate =>
                  this.setState(
                    { usersModal: null, loading: shouldUpdate },
                    () => shouldUpdate && this.handleUsers()
                  )
                }
                room={this.props.match.params.id}
                currentRoute={this.props.currentRoute}
              />
            )}
            <CModal
              show={this.state.deleteModal}
              onClose={() => this.setState({ deleteModal: false })}
              closeOnBackdrop={false}
            >
              <CModalHeader closeButton className="bg-danger">
                <CModalTitle>Excluir membro</CModalTitle>
              </CModalHeader>
              <CModalBody>
                Deseja excluir o membro selecionado da comunidade?
              </CModalBody>
              <CModalFooter>
                <CButton
                  color="danger"
                  onClick={() => this.deleteRoomUser(this.state.deleteId)}
                >
                  Apagar
                </CButton>{" "}
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ deleteModal: false })}
                >
                  Cancelar
                </CButton>
              </CModalFooter>
            </CModal>
            <CModal
              show={this.state.accessCardsModal}
              onClose={this.closeAccessCardsModal}
              closeOnBackdrop={false}
              size={this.state.accessCardsResult ? "lg" : undefined}
            >
              <CModalHeader closeButton>
                <CModalTitle>Cartões de login</CModalTitle>
              </CModalHeader>
              <CModalBody className="py-4">
                {!this.state.accessCardsResult ? (
                  <>
                    <p className="mb-3">
                      <strong>
                        Uma senha nova será criada para cada aluno.
                      </strong>{" "}
                      As senhas atuais deixarão de funcionar, e cartões
                      impressos antes ficarão inválidos.
                    </p>
                    <p className="mb-0 text-muted">
                      As senhas aparecem uma única vez, neste cartão impresso.
                      Não é possível consultá-las depois.
                    </p>
                  </>
                ) : (
                  <>
                    <p className="mb-3">
                      Senhas geradas para{" "}
                      <strong>
                        {this.state.accessCardsResult.students.length}
                      </strong>{" "}
                      {this.state.accessCardsResult.students.length === 1
                        ? "aluno"
                        : "alunos"}
                      . Imprima os cartões antes de fechar — depois disso as
                      senhas não podem mais ser consultadas.
                    </p>
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "45vh", overflowY: "auto" }}
                    >
                      <table className="table table-sm mb-0">
                        <thead>
                          <tr>
                            <th>Nome completo</th>
                            <th>Login</th>
                            <th>Senha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.accessCardsResult.students.map(
                            student => (
                              <tr key={student.user_id}>
                                <td>{student.name}</td>
                                <td className="text-monospace">
                                  {student.username}
                                </td>
                                <td className="text-monospace font-weight-bold">
                                  {student.password}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </CModalBody>
              <CModalFooter>
                {!this.state.accessCardsResult ? (
                  <CButton
                    color="primary"
                    disabled={this.state.generatingAccessCards}
                    onClick={this.handleAccessCards}
                  >
                    {this.state.generatingAccessCards
                      ? "Gerando senhas..."
                      : "Sim, gerar novas senhas"}
                  </CButton>
                ) : (
                  <CButton
                    color="primary"
                    onClick={() =>
                      this.printAccessCards(
                        this.state.accessCardsResult.room,
                        this.state.accessCardsResult.students,
                        this.state.accessCardsResult.qrImage
                      )
                    }
                  >
                    Imprimir cartões
                  </CButton>
                )}{" "}
                <CButton
                  color="secondary"
                  disabled={this.state.generatingAccessCards}
                  onClick={this.closeAccessCardsModal}
                >
                  {this.state.accessCardsResult ? "Fechar" : "Cancelar"}
                </CButton>
              </CModalFooter>
            </CModal>
            {this.state.users &&
            this.state.users.filter(user =>
              user.user_name
                .toLowerCase()
                .includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              this.props.isRoom ? (
                <>
                  {this.props.hasPrivilege && (
                    <>
                      <div className="d-flex align-items-center justify-content-end mb-3">
                        <CButton
                          color="primary"
                          onClick={() => this.setState({ usersModal: true })}
                        >
                          <i className="fa fa-plus mr-2"></i>Adicionar Membros
                        </CButton>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="m-0">Aguardando aprovação</h4>
                        <i
                          onClick={() => this.toggleWaiting()}
                          className={`text-muted users-collapse fa fa-chevron-${
                            this.state.waiting ? "up" : "down"
                          }`}
                        ></i>
                      </div>
                      <hr
                        style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                      />
                      <CCollapse show={this.state.waiting}>
                        <CRow>
                          {this.state.users
                            .filter(
                              user =>
                                user.user_name
                                  .toLowerCase()
                                  .includes(this.props.search.toLowerCase()) &&
                                !user.authorized
                            )
                            .map((user, index) => (
                              <CCol md={4} sm={6} key={index}>
                                <CCard>
                                  <CCardBody className="d-flex">
                                    <div
                                      className="bg-white mw-100"
                                      style={{
                                        width: "80px",
                                        height: "80px"
                                      }}
                                    >
                                      <CImg
                                        src={
                                          user.user_photo
                                            ? URL.img + user.user_photo
                                            : `${URL.img}uploads/users/profileEmpty.jpg`
                                        }
                                        className="rounded-circle"
                                        style={{
                                          width: "80px",
                                          height: "80px"
                                        }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column justify-content-center ml-3 text-ellipsis">
                                      <h5 className="card-title mb-1 text-ellipsis">
                                        <CLink
                                          to={`/profile/${user.user_id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          {user.user_name}
                                        </CLink>
                                      </h5>
                                      {user.role_id === 6 ? (
                                        <div className="text-ellipsis">
                                          {user.role_name} de{" "}
                                          {user.disciplines[0].discipline_name}
                                        </div>
                                      ) : (
                                        <div className="text-ellipsis">
                                          {user.role_name}
                                        </div>
                                      )}
                                      <div className="d-flex mt-1 text-ellipsis">
                                        <CButton
                                          color="danger"
                                          className="mr-2"
                                          onClick={() =>
                                            this.acceptRoomUser(user.id)
                                          }
                                        >
                                          Aprovar
                                        </CButton>
                                        <CButton
                                          variant="outline"
                                          color="danger"
                                          onClick={() =>
                                            this.deleteRoomUser(user.id)
                                          }
                                        >
                                          Apagar
                                        </CButton>
                                      </div>
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            ))}
                        </CRow>
                      </CCollapse>
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="m-0">Membros</h4>
                        <i
                          onClick={() => this.toggleMembers()}
                          className={`text-muted users-collapse fa fa-chevron-${
                            this.state.members ? "up" : "down"
                          }`}
                        ></i>
                      </div>
                      <hr
                        style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                      />
                    </>
                  )}
                  <CCollapse show={this.state.members}>
                    <CRow>
                      {this.state.users
                        .filter(
                          user =>
                            user.user_name
                              .toLowerCase()
                              .includes(this.props.search.toLowerCase()) &&
                            user.authorized
                        )
                        .map((user, index) => (
                          <CCol md={4} sm={6} key={index}>
                            <CCard>
                              <CCardBody className="d-flex text-ellipsis">
                                <div
                                  className="bg-white mw-100"
                                  style={{ width: "80px", height: "80px" }}
                                >
                                  <CImg
                                    src={
                                      user.user_photo
                                        ? URL.img + user.user_photo
                                        : `${URL.img}uploads/users/profileEmpty.jpg`
                                    }
                                    className="rounded-circle"
                                    style={{ width: "80px", height: "80px" }}
                                  />
                                </div>
                                <div
                                  className="d-flex flex-column justify-content-center pl-3 flex-1 text-ellipsis"
                                  style={{ minHeight: "80px" }}
                                >
                                  <div className="d-flex">
                                    <h5 className="card-title text-ellipsis mb-1 flex-1">
                                      {this.props.isStudent ? (
                                        <span
                                          style={{
                                            color: "inherit",
                                            cursor: "default"
                                          }}
                                        >
                                          {user.user_name}
                                        </span>
                                      ) : (
                                        <CLink
                                          to={`/profile/${user.user_id}`}
                                          style={{ color: "inherit" }}
                                        >
                                          {user.user_name}
                                        </CLink>
                                      )}
                                    </h5>
                                    {this.props.isRoom &&
                                      this.props.hasPrivilege &&
                                      !user.administrator && (
                                        <CDropdown>
                                          <CDropdownToggle
                                            color="white"
                                            className="card-header-action remove-caret"
                                          >
                                            <i className="fa fa-ellipsis-v"></i>
                                          </CDropdownToggle>
                                          <Portal>
                                            <CDropdownMenu placement="top-start">
                                              <CDropdownItem
                                                onClick={() =>
                                                  this.setState({
                                                    deleteModal: true,
                                                    deleteId: user.id
                                                  })
                                                }
                                              >
                                                Excluir
                                              </CDropdownItem>
                                            </CDropdownMenu>
                                          </Portal>
                                        </CDropdown>
                                      )}
                                  </div>
                                  {user.administrator ? (
                                    <div className="text-ellipsis">
                                      Administrador
                                    </div>
                                  ) : (
                                    <div className="text-ellipsis">Membro</div>
                                  )}
                                  <div className="text-muted text-ellipsis">
                                    Adicionado em{" "}
                                    {new Date(user.start).toLocaleDateString()}
                                  </div>
                                </div>
                              </CCardBody>
                            </CCard>
                          </CCol>
                        ))}
                    </CRow>

                    {/* Paginação */}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "15px",
                        fontFamily: "Arial, sans-serif"
                      }}
                    >
                      <button
                        className="btn-primary"
                        disabled={this.state.currentPage <= 1}
                        onClick={() =>
                          this.fetchUsers(this.state.currentPage - 1)
                        }
                        style={{
                          padding: "8px 14px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                          margin: "0px 10px 20px",
                          backgroundColor:
                            this.state.currentPage <= 1 ? "#eee" : "bg-primary",
                          color: this.state.currentPage <= 1 ? "#aaa" : "#fff",
                          cursor:
                            this.state.currentPage <= 1
                              ? "not-allowed"
                              : "pointer",
                          transition: "background-color 0.3s"
                        }}
                      >
                        Anterior
                      </button>

                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          margin: "0px 10px 20px"
                        }}
                      >
                        Página {this.state.currentPage} de{" "}
                        {this.state.totalPages}
                      </span>

                      <button
                        className="btn-primary"
                        disabled={
                          this.state.currentPage >= this.state.totalPages
                        }
                        onClick={() =>
                          this.fetchUsers(this.state.currentPage + 1)
                        }
                        style={{
                          padding: "8px 14px",
                          borderRadius: "5px",
                          margin: "0px 10px 20px",
                          border: "1px solid #ccc",
                          backgroundColor:
                            this.state.currentPage >= this.state.totalPages
                              ? "#eee"
                              : "bg-primary",
                          color:
                            this.state.currentPage >= this.state.totalPages
                              ? "#aaa"
                              : "#fff",
                          cursor:
                            this.state.currentPage >= this.state.totalPages
                              ? "not-allowed"
                              : "pointer",
                          transition: "background-color 0.3s"
                        }}
                      >
                        Próxima
                      </button>
                    </div>
                  </CCollapse>
                </>
              ) : (
                <CRow>
                  {/* Sem CCard aqui: o DataTable já renderiza o seu próprio
                      card. Envolver num segundo card criava borda dentro de
                      borda. O CCol cuida da margem externa. */}
                  <CCol md={12}>
                    <DataTable
                      responsiveCards
                      noClick
                      noSort
                      /* `remote` é o que liga a paginação ao servidor. Sem
                         ela o tables.jsx zera onPageChange e page, e manda
                         remote={false} para o BootstrapTable -- que então
                         pagina só sobre as 10 linhas que recebeu, conclui
                         que existe 1 página e não avança. As três props
                         abaixo (currentPage/totalItems/perPage) só são lidas
                         quando `remote` está presente. */
                      remote
                      list={this.state.users}
                      title="Usuários da turma"
                      subtitle="Tenha acesso as informações dos membros da turma"
                      extraComponent={
                        this.props.general.active_roles &&
                        this.props.general.active_roles.role_id !== 7 ? (
                          <CButton
                            color="primary"
                            className="text ml-2 text-nowrap btn-toolbar-extra"
                            onClick={this.openAccessCardsModal}
                            title="Gerar cartões com login, senha e QR Code para os alunos desta turma"
                          >
                            Cartões de login
                          </CButton>
                        ) : null
                      }
                      currentPage={this.state.studentsListPage}
                      totalItems={this.state.studentListSize}
                      perPage={this.state.sizePerPage}
                      onPageChange={page =>
                        this.setState({ studentsListPage: page }, () =>
                          this.handleUsers()
                        )
                      }
                      onSizePerPageList={size =>
                        this.setState({ sizePerPage: size }, () =>
                          this.handleUsers()
                        )
                      }
                      header={[
                        { name: "user_name", denomination: "Nome" },
                        {
                          name: "role_name",
                          denomination: "Papel"
                        },
                        {
                          name: "username",
                          denomination: "Usuário"
                        },
                        {
                          /* Grupos do aluno dentro desta turma. Vem pronto do
                             listPaginate; ordenar por aqui não faria sentido
                             (a célula é uma lista, não um valor). */
                          name: "groups",
                          denomination: "Grupo(s)",
                          dataSort: false,
                          dataFormat: this.cellGroups
                        },
                        {
                          name: "start",
                          denomination: "Data de entrada na turma"
                        }
                      ]}
                    />
                  </CCol>
                </CRow>
              )
            ) : (
              <div className="d-flex align-items-center justify-content-center m-3">
                Nenhum membro encontrado
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentUsers);
